import React, { useState, useEffect } from "react";
import { Card, Grid, TextField, Button, Box } from "@mui/material";
import moment from "moment";

function Filter({
  setSearchparams,
  subscriberData,
  fetchSubscribers,
  setPaginationModel,
}) {

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [status, setStatus] = useState("");
  const [filterBy, setFilterBy] = useState("");
  const [filterByPro, setFilterByPro] = useState("");
  const [transactionMode, setTransactionMode] = useState("");
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    if (Array.isArray(subscriberData.data)) {
      const uniqueProducts = new Map(
        subscriberData.data
          .filter(
            (data) =>
              data?.product_plan_pricing?.productPlan?.product?.name &&
              data?.product_plan_pricing?.productPlan?.product?.uuid
          )
          .map((data) => {
            const productName =
              data.product_plan_pricing.productPlan.product.name;
            const productUuid =
              data.product_plan_pricing.productPlan.product.uuid;
            return [productName, productUuid];
          })
      );

      const productList = Array.from(uniqueProducts.entries()).map(
        ([name, uuid]) => ({
          name,
          uuid,
        })
      );

      setProductList(productList);
    } else {
      setProductList([]);
    }
  }, [subscriberData]);

  const handleSearch = () => {
    const params = {
      product_uuid:
        selectedProducts.length > 0 ? selectedProducts[0] : undefined,
      from: fromDate
        ? moment.utc(fromDate).startOf("day").format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        : null,
      to: toDate
        ? moment.utc(toDate).endOf("day").format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        : null,
      subscription_status: status || undefined,
      date_filter_by: filterBy || undefined,
      payment_mode: transactionMode || undefined,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );

    setSearchparams(filteredParams);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
  };

  const handleReset = () => {
    setSelectedProducts([]);
    setFromDate(null);
    setToDate(null);
    setStatus("");
    setFilterBy("");
    setFilterByPro("");
    setTransactionMode("");
    fetchSubscribers();
    setSearchparams({});
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
  };

  return (
    <Card sx={{ p: 3, mb: 2 }} elevation={4}>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <TextField
            select
            label="Product Name"
            value={filterByPro}
            onChange={(e) => {
              const selectedProductName = e.target.value;
              const selectedProduct = productList.find(
                (product) =>
                  product.name?.toLowerCase().trim() ===
                  selectedProductName?.toLowerCase().trim()
              );

              if (selectedProduct) {
                setFilterByPro(selectedProductName);
                setSelectedProducts([selectedProduct.uuid]);
              }
            }}
            fullWidth
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
          >
            <option value="">Select</option>
            {productList.map((product, index) => (
              <option key={index} value={product.name?.toLowerCase().trim()}>
                {product.name}
              </option>
            ))}
          </TextField>
        </Grid>

        <Grid item>
          <TextField
            select
            label="Status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            fullWidth
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
          >
            <option value="">Select</option>
            <option value="active">Active</option>
            <option value="cancelled">Cancelled</option>
            <option value="expired">Expired</option>
          </TextField>
        </Grid>

        <Grid item>
          <TextField
            select
            label="Filter By"
            value={filterBy}
            onChange={(e) => setFilterBy(e.target.value)}
            fullWidth
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
          >
            <option value="">Select</option>
            <option value="start_date">Subscribed/Renewed On</option>
            <option value="payment_date">Transaction</option>
            <option value="expiry_date">Expiry</option>
          </TextField>
        </Grid>

        <Grid item>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <TextField
              id="outlined-basic"
              value={fromDate ? moment(fromDate).format("YYYY-MM-DD") : ""}
              onChange={(e) => {
                setFromDate(e.target.value);
              }}
              label="From Date"
              variant="outlined"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              disabled={filterBy === ""}
            />
          </Box>
        </Grid>
        <Grid item>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <TextField
              id="outlined-basic"
              value={toDate ? moment(toDate).format("YYYY-MM-DD") : ""}
              onChange={(e) => {
                setToDate(e.target.value);
              }}
              label="To Date"
              variant="outlined"
              type="date"
              disabled={filterBy === ""}
              inputProps={{
                min: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            fullWidth
            onClick={handleSearch}
            sx={{
              height: "100%",
              background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
              color: "#fff",
              borderRadius: "8px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              textTransform: "uppercase",
              fontWeight: "bold",
              "&:hover": {
                background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            Search
          </Button>
        </Grid>

        <Grid item>
          <Button
            variant="outlined"
            fullWidth
            onClick={handleReset}
            sx={{
              height: "100%",
              color: "#ff4b2b",
              borderColor: "#ff4b2b",
              borderRadius: "8px",
              textTransform: "uppercase",
              fontWeight: "bold",
              "&:hover": {
                borderColor: "#ff416c",
                color: "#ff416c",
              },
            }}
          >
            Reset
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}

export default Filter;
